// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { ApplicationKindSchema } from '../inputTypeSchemas/ApplicationKindSchema'
import { ScanEffortLevelSchema } from '../inputTypeSchemas/ScanEffortLevelSchema'
import { SignalCategorySchema } from '../inputTypeSchemas/SignalCategorySchema'
import { CvssVersionSettingSchema } from '../inputTypeSchemas/CvssVersionSettingSchema'

/////////////////////////////////////////
// APPLICATION SCHEMA
/////////////////////////////////////////

export const ApplicationSchema = z.object({
  kind: ApplicationKindSchema,
  scanEffortLevel: ScanEffortLevelSchema.nullable(),
  signalCategoriesInScope: SignalCategorySchema.array(),
  cvssVersion: CvssVersionSettingSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  url: z.string(),
  redirectToUrl: z.string().nullable(),
  documentationUrls: z.string().array(),
  environment: z.string(),
  owner: z.string().nullable(),
  hasWaf: z.boolean().nullable(),
  isInternalApp: z.boolean().nullable(),
  twingateNetworkId: z.string().nullable(),
  tailscaleNetworkId: z.string().nullable(),
  isBackendOnly: z.boolean().nullable(),
  smokeTestEnabled: z.boolean().nullable(),
  lastWeeklyCrawlAt: z.coerce.date().nullable(),
  nextPentestReportDate: z.coerce.date().nullable(),
  nextPentestReportReminderSentAt: z.coerce.date().nullable(),
  scheduledReportsEnabled: z.boolean(),
  dynamicApplicationScanEnabled: z.boolean(),
  dynamicApplicationScanCredentialId: z.string().nullable(),
  dynamicApplicationScanVulnerabilityEnabled: z.boolean(),
  dynamicApplicationScanDirectoryEnabled: z.boolean(),
  targetRequestsPerMinute: z.number().int().nullable(),
  anonymousKatanaDispatchedAt: z.coerce.date().nullable(),
  limitGlobalHeadersByScope: z.boolean().nullable(),
  supportsParallelExecution: z.boolean().nullable(),
  waitingHoursForDeployment: z.number().int(),
  applyDeploymentDelayToTicketingRetests: z.boolean(),
  isEnabled: z.boolean().nullable(),
  torchEnabled: z.boolean().nullable(),
  isDraft: z.boolean().nullable(),
  sourceSurfaceId: z.string().nullable(),
  signalImportHostAliases: JsonValueSchema.nullable(),
  signalImportMountMappings: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Application = z.infer<typeof ApplicationSchema>

export default ApplicationSchema;
